import React from 'react';
import { Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import Spinner from 'layouts/public/spinner/Spinner'

class SponsorTypeSummary extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
        return {
			loading: true,
			sponsorTypes: [],
			amountInvestedBySponsors: null
		};
    }

    componentDidMount() {
		this.get();
    }

	get = () => {
        new API().post(APIModules.Admin.url('/discountCodeDashboard/getSponsorTypeSummary'), null,
            {
                success: (r) => {
                    this.setState({ sponsorTypes: r.data.items, loading: false, amountInvestedBySponsors: r.data.amountInvestedBySponsors });
                }
			});

    }

	getAmountInvestedBySponsorsExport = () => {
		new API().post(APIModules.Admin.url('/discountCodeDashboard/getAmountInvestedBySponsorsExport'), null,
		{
			success: (sr) => {
				new API().download(sr.data);
			}
		});
	}

	renderSponsorTypes = () => {

		let items = [];

		this.state.sponsorTypes.forEach((st) => {
			items.push(
				<tr key={st.sponsorTypeCode}>
					<td className="react-grid-Cell">(<b>{st.sponsorTypeCode}</b>) {st.description}</td>
					<td className="react-grid-Cell">
						{st.total > 0 ?
							<Link to={'/admin/discountCodeSetup?sponsorTypeCode=' + st.sponsorTypeCode + "&sponsorTypeName=" + encodeURIComponent(st.description)}>
								{st.total}
							</Link>
						:
							<span>-</span>
						}
					</td>
				</tr>
			);
		});

		items.push(
			<tr key="AmountInvested">
				<td className="react-grid-Cell"><b>Amount Invested by Sponsors</b></td>
				<td className="react-grid-Cell">
					{this.state.amountInvestedBySponsors > 0 ?
						<Link to="#" onClick={this.getAmountInvestedBySponsorsExport}>{this.state.amountInvestedBySponsors}</Link>
					:
						<span>{this.state.amountInvestedBySponsors}</span>
					}	
				</td>
			</tr>
		);

		return items;
	}

	render() {
		if (this.state.loading)
			return <Spinner />

		return (
			<Table condensed>
				<thead>
					<tr>
						<th className="col-md-2">Sponsor Type (S-Type)</th>
						<th className="col-md-2">Total</th>
					</tr>
				</thead>
				<tbody>
					{this.renderSponsorTypes()}
				</tbody>
			</Table>
		)
	}
}

export default SponsorTypeSummary;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDiscountCodeDashboard/sponsorTypeSummary/SponsorTypeSummary.js